export default __webpack_public_path__ + "static/media/122.350186a9.gif";